

import _get from 'lodash.get';
import React, { memo } from 'react';







const FiltersGroupLabel = ({
  label, stats: { global: stats } = {}, statKey
}) =>
<>
    {label && `${label}${stats && statKey ? ` (${_get(stats, statKey)})` : ''}`}
  </>;


export default memo(FiltersGroupLabel);